import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// import PropTypes from "prop-types";
import * as removeActions from "../actions/removeActions";
import StateManager from "../../shared/utils/StateManager";
import WorkersTab from "../../shared/components/tabs/workers/WorkersTab";
import {I18nUtils} from "../../../i18n/I18nUtils";

class RemoveCardTabWorkers extends React.Component {

  static TAB_ID = 'workers';

  static renderTabHeader() {
    return (
      <li role="presentation" className="active">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_TRABAJADORES').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade active in" id={RemoveCardTabWorkers.TAB_ID}>
        <WorkersTab
          id={StateManager.REMOVE_TAB_WORKERS}
          title={I18nUtils.tr('TR_ELIMINAR_TRABAJADORES')}
          selectedIds={this.props.selectedIds}
          actionSelectItem={this.props.removeActions.checkWorker}
          actionSelectAll={this.props.removeActions.checkWorkers}
          selectText={I18nUtils.tr('TR_ELIMINAR')}
          selectAllText={I18nUtils.tr('TR_ELIMINAR_TODO')}
          showOutsource={true}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const workerIds = state.remove.workers.map(worker => worker.id);
  return {
    selectedIds: workerIds,
  }
};

const mapDispatchToProps = dispatch => ({
  removeActions: bindActionCreators(removeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveCardTabWorkers)

RemoveCardTabWorkers.propTypes = {
};

RemoveCardTabWorkers.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/remove/components/RemoveCardTabWorkers.js